module.exports = __webpack_public_path__ + "static/img/1810_6.6d9f615.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_6.jpg
// module id = tmSH
// module chunks = 1